enum Lang {
  EN = 'EN',
  PL = 'PL',
}

export default Lang
